export default {
  SET_FILE_LIST(state, files) {
    state.list = files;
  },
};
